import {
    ContainerGeoLocation,
} from 'app/Apps/ContainerManagement/Containers/containers.types'
import {
    DTOCardFormField,
} from 'app/types/form.types'

const geolocationFields: DTOCardFormField<keyof ContainerGeoLocation>[] = [{
    title: 'INFORMATION',
    fields: [
        {
            id: 'column1',
            fields: [
                {
                    name: 'latitude',
                    componentName: 'InputSingleline',
                    labelKey: 'LATITUDE',
                },
                {
                    name: 'timestamp',
                    componentName: 'InputSingleline',
                    noLabel: true,
                    className: 'timestamp',
                    labelKey: 'TIMESTAMP',
                },
            ],
        },
        {
            id: 'column2',
            fields: [{
                name: 'longitude',
                componentName: 'InputSingleline',
                labelKey: 'LONGITUDE',
            }],
        },
    ],
}]

export default geolocationFields
